<template>
  <div>
    <div
      class="style1"
      :class="{
        must: fieldObj.required == 1,
        err: fieldObj.dirty && fieldObj.invalid
      }"
    >
      <div class="u-label">{{ fieldObj.displayName }}</div>
      <div class="m-input">
        <a-date-picker
          v-if="dateType === 'year'"
          :locale="locale"
          mode="year"
          format="YYYY"
          :value-format="fieldObj.valueformat"
          :placeholder="'请选择' + fieldObj.displayName"
          v-model="timeValue"
          :open="isopen"
          @change="handleChange2"
          @openChange="handleOpenChange"
          @panelChange="handlePanelChange"
        />
        <a-month-picker
          v-else-if="dateType === 'month'"
          :locale="locale"
          :value-format="fieldObj.valueformat"
          :placeholder="'请选择' + fieldObj.displayName"
          v-model="timeValue"
          @change="handleChange"
        />
        <a-date-picker
          v-else
          :locale="locale"
          :show-time="fieldObj.showTime"
          :format="fieldObj.format"
          :value-format="fieldObj.valueformat"
          :placeholder="'请选择' + fieldObj.displayName"
          v-model="timeValue"
          @change="handleChange"
        />
      </div>
      <div class="u-reg-err-tips" v-show="fieldObj.dirty && fieldObj.invalid">
        请选择日期
      </div>
    </div>
  </div>
</template>
<script>
import datePickerMixin from "../../field/new-fields/date-picker";
export default {
  name: "sk-date-picker",
  mixins: [datePickerMixin]
};
</script>
<style lang=""></style>
